import jwtDecode, { JwtPayload } from 'jwt-decode';
import moment from 'moment';
import api from './api';
import xhr from './xhr';

const getRefreshToken = async () => {
  const tokenInicial = localStorage.getItem('token');

  if (tokenInicial) {
    const decoded: JwtPayload = jwtDecode(tokenInicial);
    const tokenExpired = moment.unix(decoded.exp || 0);

    if (moment() > tokenExpired) {
      const refresh = localStorage.getItem('refreshToken');
      const {
        data: {
          token,
          refresh_token: refreshTokenRetorno,
        },
      } = await api.refreshToken(refresh);

      localStorage.setItem('refreshToken', refreshTokenRetorno);
      localStorage.setItem('token', token);

      // Força atualização do header com novo token
      xhr.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('token')}`;
    }
  }
};

export default {
  getRefreshToken,
};
